var map = {
	"./am.json": 3012,
	"./ar.json": 2045,
	"./bn.json": 9102,
	"./en.json": 3341,
	"./es.json": 7510,
	"./fa.json": 1695,
	"./fr.json": 9998,
	"./ht.json": 5770,
	"./iw.json": 1142,
	"./km.json": 4566,
	"./ml.json": 8347,
	"./ps.json": 687,
	"./pt.json": 8722,
	"./ru.json": 3991,
	"./so.json": 8892,
	"./sq.json": 234,
	"./sw.json": 5140,
	"./vi.json": 9783,
	"./yo.json": 2238,
	"./zh-CN.json": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9141;